require('lib/browser_required')('module/viewer/viewer')

const ViewerController = require('./viewer_controller')

module.exports = new ViewerController()
